import { WebsiteLink } from 'client/components/core/Sidebar/components/Settings/components/website-link'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import React from 'react'
import { ButtonLinkActionSettingsLayout } from 'src/editor/shared/settings/button/button-link-action-settings-layout'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { WebsiteLinkWebsiteActionButtonEntityInterface } from 'src/shared/entities/website-button/website-link-website-button.schema'

export const WebsiteButtonWebsiteLinkActionSettings = ({
  entity,
}: SettingsProps<WebsiteButtonEntityInterface>) => {
  const updateProp = useUpdateProp(
    entity as WebsiteLinkWebsiteActionButtonEntityInterface,
  )

  return entity.action === ButtonActionTypeEnum.WebsitePageLink ? (
    <ButtonLinkActionSettingsLayout entity={entity}>
      <WebsiteLink
        link={entity.linkUrl}
        update={updateProp('linkUrl')}
        withoutWrapper={false}
        labelText="entity_settings.button.website_links.label"
      />
    </ButtonLinkActionSettingsLayout>
  ) : null
}
